export default __webpack_public_path__ + "static/media/strong 5 self assesment.fa047cc0.png";